export const formatFocalLengthMm = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  const numericValue = Number.parseFloat(value);
  if (!Number.isFinite(numericValue)) {
    return "";
  }

  if (Number.isInteger(numericValue)) {
    return `${numericValue}mm`;
  }

  return `${numericValue.toString().replace(/\.?0+$/, "")}mm`;
};

export const formatFocalLengthRange = (minValue, maxValue) => {
  const minLabel = formatFocalLengthMm(minValue).replace(/mm$/, "");
  const maxLabel = formatFocalLengthMm(maxValue).replace(/mm$/, "");

  if (!minLabel && !maxLabel) {
    return "";
  }

  if (minLabel && maxLabel && minLabel !== maxLabel) {
    return `${minLabel}-${maxLabel}mm`;
  }

  return `${minLabel || maxLabel}mm`;
};

export const getLensSeriesLabel = (lens, { includeBrand = true } = {}) => {
  if (!lens) {
    return "";
  }

  return [includeBrand ? lens.brand : null, lens.series]
    .filter(Boolean)
    .join(" ")
    .trim();
};

export const getLensSeriesKey = (lens) => {
  if (!lens) {
    return "";
  }

  return [lens.brand, lens.series]
    .filter(Boolean)
    .join("::")
    .trim()
    .toLowerCase();
};

export const getLensDisplayName = (
  lens,
  { includeBrand = true, includeFocal = true } = {},
) => {
  if (!lens) {
    return "";
  }

  const focalLengthLabel = includeFocal
    ? (
      lens.focal_length_label
      || formatFocalLengthRange(lens.focal_length_min_mm, lens.focal_length_max_mm)
      || formatFocalLengthMm(lens.focal_length_mm)
    )
    : "";

  return [includeBrand ? lens.brand : null, lens.series, focalLengthLabel]
    .filter(Boolean)
    .join(" ")
    .trim();
};
